import type { CachedEntityRecord } from '@/shared/db/schema';
import {
  CACHED_METER_TYPE_LABELS,
  type CachedMeterSearchData,
  METER_IDENTIFIER_KINDS,
  type MeterIdentifierKind,
  type NormalizedMeterIdentifier,
  normalizeSearchField,
} from '@/shared/meter-identification';

const searchableFields = ['apiKey', 'toolsId', 'devEui', 'imsi', 'serial'] as const;

export function getMatchedMeterSearchField(
  data: CachedMeterSearchData,
  identifier: NormalizedMeterIdentifier,
): MeterIdentifierKind | null {
  for (const field of searchableFields) {
    if (normalizeSearchField(data[field]) === identifier.normalizedValue) {
      return fieldToKind(field);
    }
  }

  return null;
}

export function toMeterSearchData(record: CachedEntityRecord): CachedMeterSearchData {
  const data = record.data as CachedMeterSearchData;

  return {
    ...data,
    commodity: data.commodity ?? CACHED_METER_TYPE_LABELS.unknown,
  };
}

function fieldToKind(field: (typeof searchableFields)[number]): MeterIdentifierKind {
  if (field === 'apiKey') {
    return METER_IDENTIFIER_KINDS.apiKey;
  }

  if (field === 'toolsId') {
    return METER_IDENTIFIER_KINDS.toolsId;
  }

  if (field === 'devEui') {
    return METER_IDENTIFIER_KINDS.devEui;
  }

  return field;
}
